export default {
  "blockStyleSpacing": "gjPfd",
  "codeBlock": "IhmzM gjPfd",
  "renderedInTable": "HY93x"
};